import { iNotification, Store } from "react-notifications-component";
import create from "zustand";
import Constants from "./constants";

interface OFVNotification {
  visible?: boolean;
  title?: string;
  message?: string;
  isError: boolean;
  duration?: number;
}

interface GlobalState {
  user: any;
  notification: OFVNotification;
  bpmsActive?: boolean;
  loading?: boolean;
  updateUser: (user: any) => void;
  showNotification: (notification: OFVNotification) => void;
  updateBPMSActive: (bpmsActive: boolean) => void; 
  hideNotification: (isError: boolean) => void;
  showLoading: () => void;
  hideLoading: () => void;
}

export const useGlobalStore = create<GlobalState>((set) => ({
  // initial state
  user: JSON.parse(localStorage.getItem("user") || "null"),
  bpmsActive: localStorage.getItem(Constants.ACTIVAR_BPMS_BENEFICIO) === "true", 
  notification: {
    visible: false,
    isError: false,
  },

  // methods for manipulating state
  updateUser: (user: any) => {
    localStorage.setItem(Constants.USER, JSON.stringify(user));
    set((state) => ({
      ...state,
      user: user,
    }));
  },
  updateBPMSActive: (bpmsActive: boolean) => {
    set((state) => ({
      ...state,
      bpmsActive, // Update bpmsActive state
    }));
    localStorage.setItem(Constants.ACTIVAR_BPMS_BENEFICIO, JSON.stringify(bpmsActive)); // Persist to localStorage
  },
  showNotification: (notification: OFVNotification) => {
    const notificationA: iNotification = {
      title: notification.title,
      message: notification.message,
      type: notification.isError ? "danger" : "success",
      insert: "top",
      container: "top-right",
      animationIn: ["animate__animated animate__fadeIn"], // `animate.css v4` classes
      animationOut: ["animate__animated animate__fadeOut"], // `animate.css v4` classes
    };
    Store.addNotification({
      ...notificationA,
      dismiss: {
        duration: notification.duration || 10000,
        onScreen: true,
        showIcon: true
      },
    });
  },
  hideNotification: (isError: boolean) => {
    set((state) => ({
      ...state,
      notification: { visible: false, isError: isError },
    }));
  },
  showLoading: () => {
    set((state) => ({
      ...state,
      loading: true,
    }));
  },
  hideLoading: () => {
    set((state) => ({
      ...state,
      loading: false,
    }));
  },
}));
